// Poll schedule for the "Prices on their way" re-read (flag
// REACT_APP_PRODUCT_PENDING_ENABLED). Pure module - no flag reads here, so
// enviroment.ts can import the default without a cycle.
//
// The API's product-refresh worker answers p50 < 4 s after the mutation
// (queue wait ~0.3 s + NAV FindTemplate2 0-3 s), so the first re-read at 3 s
// catches most cases, the second at 8 s the slow NAV ones, and the third at
// 15 s is the last attempt; after that the badge simply stays until the
// user opens the item again (a new view = a new budget).
export const DEFAULT_PRODUCT_PENDING_POLL_MS: readonly number[] = [
  3_000, 8_000, 15_000,
];

// Owner rule: at most 3 price-endpoint calls per pending view. Same cap as
// the high-res heal (MAX_HEAL_ATTEMPTS); parseHealDelaysMs enforces it on
// the env override.
export const MAX_PRODUCT_PENDING_POLLS = 3;

// The delay before poll number `attempt` (0-based), or undefined when the
// budget is spent. Pure so the plan can be unit-tested without timers.
export function productPendingPollDelay(
  attempt: number,
  delays: readonly number[] = DEFAULT_PRODUCT_PENDING_POLL_MS
): number | undefined {
  if (!Number.isInteger(attempt) || attempt < 0) return undefined;
  if (attempt >= MAX_PRODUCT_PENDING_POLLS) return undefined;
  return delays[attempt];
}
